export class ReportObj {
  name: string;
  value: number;
  series: Array<ReportObj>;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/report-obj.ts